import { Brand } from "../../../models/brand.model.ts";
import { BrandSerializer } from "../../../models/serializers/brandSerializer.ts";
import { httpRequest } from "../../http";

export class CommandUpdateOrganizationBrand {
    async run(organizationId: string, brandForm: Brand) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandForm.id}`
        
        const formData = await this.formData(brandForm);
        try {
            const response = await httpRequest<any>(url, { method: "POST", body: formData });
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async formData(brandForm: Brand) {
        const form = new FormData();
        if(brandForm.logo)
            form.append('logo', brandForm.logo);
        form.append('name', brandForm.name);
        form.append('company_site_url', brandForm.company_site_url);
        form.append('primary_color_code', brandForm.primary_color_code);
        form.append('secondary_color_code', brandForm.secondary_color_code);
        form.append('tertiary_color_code', brandForm.tertiary_color_code);
        form.append('tag_line', brandForm.tag_line);
        console.log("FORMDATA ", form)
        return form;

    }

    deserialize(data: any) : Brand{
        const serializer = new BrandSerializer();
        return serializer.deserialize(data);
    }

  
}



